<template>
  <div>
    <div class="flex-col-center" style="padding-top: 75px;">
					<img src="@images/success1.png" style="width: 149px;height: 144px;" />
					<div class="tips">提交成功</div>
          <div class="desc">{{title}}</div>
			</div>
			<div class="u-buttom">
				<button class="qualified" hover-class="button-hover" @click="goBack">完成</button>
			</div>
    
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      isBack: false,
      title: '感谢您的反馈!'
    }
  },
  created() {
    let params = this.$route.params
    if (params) {
      this.isBack = params.isBack || false
			this.title = params.title || '感谢您的反馈!'
    }
  },
  mounted() {},
  methods: {
    goBack() {
      if (this.isBack) {
        this.$router.go(-1)
      } else {
        wx.closeWindow()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.flex-col-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
/*说明*/
.tips {
  font-size: 20px;
  color: #333333;
  margin-top: 20px;
  font-weight: 400;
}
.desc {
  font-size: 15px;
  color: #666666;
  margin-top: 14px;
  font-weight: 400;
}

.u-buttom {
  margin-top: 60px;
  display: flex;
  width: 100%;
  justify-content: center;

  button {
    width: 80%;
    height: 46px;
    border-radius: 50px;
    color: #ffffff;
    border: none;
  }

  .unqualified {
    background: #ccc;
  }

  .qualified {
    background: linear-gradient(137deg, #40a2ff 0%, #1e69ff 100%);
    box-shadow: 0px 6px 10px 0px #c4d9ff;
  }

  .button-hover {
    opacity: 0.9;
  }
}
</style>
